// extracted by mini-css-extract-plugin
export default {"container":"mod_1SJir"};